module.exports = __webpack_public_path__ + "img/icon-2.e0ed6568.png";